import { render, staticRenderFns } from "./redemption-code.vue?vue&type=template&id=3fb4749f&scoped=true&lang=pug&"
import script from "./redemption-code.vue?vue&type=script&lang=js&"
export * from "./redemption-code.vue?vue&type=script&lang=js&"
import style0 from "./redemption-code.vue?vue&type=style&index=0&id=3fb4749f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4749f",
  null
  
)

export default component.exports